// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid #E1E1FB;
  background: white;
  overflow: hidden;
}

.button-container {
  display: flex;
}

button {
  color: var(--grey-icon);
  height: 28px;
  width: 38px;
  background: white;
  border: none;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.2s ease;
}

button.active {
  border: 1px solid #E1E1FB;
  background: #E1E1FB;
  color: var(--primary);
}

button:hover:not(.active) {
  color: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/app/translate/components/lang-switcher/lang-switcher.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[":host{\n  display: inline-block;\n  box-sizing: border-box;\n  border-radius: 14px;\n  border: 1px solid #E1E1FB;\n  background: white;\n  overflow: hidden;\n}\n\n.button-container {\n  display: flex;\n}\n\nbutton {\n  color: var(--grey-icon);\n  height: 28px;\n  width: 38px;\n  background: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 14px;\n  transition: all 0.2s ease;\n}\n\nbutton.active {\n  border: 1px solid #E1E1FB;\n  background: #E1E1FB;\n  color: var(--primary);\n}\n\nbutton:hover:not(.active) {\n  color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
